import React from 'react';
import { Link } from 'react-router-dom';
import V3Header from '../components/V3Header';
import V3Footer from '../components/V3Footer';
import BlogMeta from '../components/BlogMeta';
import { useLanguage } from '../LanguageContext';
import { blogPosts } from '../content/blogPosts';
import useSeo from '../useSeo';
import '../V3.css';

const CardBody = ({ post, t }) => (
  <div className="v3-blog-card-body">
    {post.category && <span className="v3-blog-tag">{post.category}</span>}
    <h3>{post.title}</h3>
    <BlogMeta
      author={post.author}
      authorLinkedin={post.authorLinkedin}
      dateLabel={post.dateLabel}
      readTime={post.readTime}
      byLabel={t('common.blogBy')}
    />
    <p className="v3-blog-excerpt">{post.excerpt}</p>
    <span className="v3-blog-readmore">{t('common.blogReadMore')}</span>
  </div>
);

const V3Blog = () => {
  const { t } = useLanguage();
  const [featured, ...rest] = blogPosts;

  useSeo({
    title: 'Blog | BRAHMOID',
    description: t('common.blogIntro'),
    path: '/blog',
  });

  return (
    <div className="v3-app">
      <div className="v3-page">
        <V3Header activeNav="blog" />
        <div className="v3-hero">
          <h1>{t('common.navBlog')}</h1>
          <p>{t('common.blogIntro')}</p>
        </div>

        <section className="v3-block">
          {featured && (
            <Link to={`/blog/${featured.slug}`} className="v3-blog-card v3-blog-featured">
              {featured.image && (
                <div className="v3-blog-thumb v3-blog-thumb-featured">
                  <img src={featured.image} alt={featured.imageAlt || featured.title} loading="eager" />
                </div>
              )}
              <CardBody post={featured} t={t} />
            </Link>
          )}

          {rest.length > 0 && (
            <div className="v3-blog-grid">
              {rest.map((post) => (
                <Link
                  key={post.slug}
                  to={`/blog/${post.slug}`}
                  className={`v3-blog-card${post.image ? '' : ' v3-blog-card--text'}`}
                >
                  {post.image && (
                    <div className="v3-blog-thumb">
                      <img src={post.image} alt={post.imageAlt || post.title} loading="lazy" />
                    </div>
                  )}
                  <CardBody post={post} t={t} />
                </Link>
              ))}
            </div>
          )}
        </section>
        <V3Footer />
      </div>
    </div>
  );
};

export default V3Blog;
